module.exports = __webpack_public_path__ + "img/phone.1c7ae4b4.png";